import { Divider, Drawer, Space, Select, Tooltip, Button, Checkbox, Spin } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import PositionAlign from "../../UI/PositionAlign";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import { fetchImage } from "../../../utils/Api";
import Segments from "../../UI/Segments";
import { PaddingHorizontalIcon, PaddingVerticalIcon, AlignLeftIcon, AlignRightIcon, AlignCenterIcon } from "../../Icons";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { tt_ig_display, tt_ig_gap_x, tt_ig_gap_y, tt_ig_padding_x, tt_ig_padding_y, tt_name_block_warning } from "../../../utils/Utils";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import PresetPicker from "../../../globals/styles/PresetPicker";
import Html from "../../../utils/Html";
import LinkPicker from "../../../globals/styles/LinkPicker";
import MobileSelector from "../../UI/MobileSelector";
import SliderInput from "../../UI/SiderInput";
export default function TextColumns(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [mobile, setMobile] = useState(false)
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 1248,
        contained = false,
        padding_y = 10,
        padding_x = 10,
        background_colour = 0,
        segments = [
            { headline: "Headline", label : "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames primis in faucibus." },
            { headline: "Headline", label : "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames primis in faucibus." },
            { headline: "Headline", label : "Unnamed", paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames primis in faucibus." },
        ],
        headline_preset = 0,
        paragraph_preset = 0,
        column_text_align = "left",
        link_id = 0,
        align = "center",
        gap = 10,
        spacer = 0,
        spacer_colour = 0,
        border = 0,
        border_colour = 0,
        columns = 3,
        allow_segment_breaks = false,
        mobile_columns = 1,
        mobile_padding_y = 10,
        mobile_padding_x = 10,
        allow_mobile_overrides = false,

    } = data;





    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = (_image) => {
        if (_image.link) {
            window.open(_image.link, (_image.tab) ? "_blank" : "_self");
        }
    }



    const drawRender = () => {

        const m = (allow_mobile_overrides && view !== "desktop") ? true : false;

        const _style = {
            background: getColor(background_colour, template),
            border: border + "px solid " + getColor(border_colour, template, "#000"),
            padding: (m) ? `${mobile_padding_y}px ${mobile_padding_x}px` : `${padding_y}px ${padding_x}px`,
            width: (contained && !m) ? width + "px" : "100%",
            margin: align,
            textAlign: column_text_align
        };



        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                    <div style={{ columnCount: (m) ? mobile_columns : columns, columnGap: gap + "px" }}>
                        {segments.map((item, index) => (
                            <div key={index} style={{ marginBottom: '10px', breakInside: (allow_segment_breaks) ? "auto" : "avoid", }}>
                                {(item?.path && <img style={{ "maxWidth": "100%" }} src={fetchImage(item.path)} />)}
                                {(item?.headline && <h2 style={{ "display": "block" }} className={"bm-txt-" + headline_preset} >
                                    {item.headline}
                                </h2>)}

                                {(item?.paragraph &&
                                    <div className={"bm-component  bm-txt-" + paragraph_preset} >
                                        <Html anchor={"bm-lnkin-"+link_id} html={item.paragraph} />
                                    </div>
                                )}

                                {((index !== segments.length - 1 && spacer > 0) && <Divider style={{ "borderTop": spacer + "px solid " + getColor(spacer_colour, template, "#000") }} />)}

                            </div>
                        ))}
                    </div>


                    {/* {images.map((item, index) => {
                        return drawImage(item, index);
                    })} */}
                </div>
            </div>
        )
    }


    const drawDesktop = () => {

        return (
            <div>


                {/* IMAGES */}
                <Segments container={container} link_id={link_id} paragraph_preset={paragraph_preset} background_colour={background_colour} extra data={data} setData={setData} segments={segments} />
                <div className="shim" /> <div className="shim" />


                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLUMNS</Divider>
                <div className="float-flex">
                    <BMInput width={"50px"} value={columns} onChange={(e) => setData({ ...data, "columns": e })} number min={1} max={8} />
                </div>

                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        disabled={!contained}
                        value={width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "contained": e.target.checked })} checked={contained}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLUMN TEXT ALIGN</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "column_text_align": "left" })} style={{ "color": (column_text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "column_text_align": "center" })} style={{ "color": (column_text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "column_text_align": "right" })} style={{ "color": (column_text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                <PresetPicker value={headline_preset} onChange={(e) => setData({ ...data, "headline_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / BREAK</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <Checkbox onChange={(e) => setData({ ...data, "allow_segment_breaks": e.target.checked })} checked={allow_segment_breaks}><small>Allow segment breaks?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* BORDER COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BORDER / COLOUR</Divider>
                <div style={{ "gap": "5px" }} className="float-flex">
                    <ColourPicker allow_none value={border_colour} onChange={(_v) => setData({ ...data, "border_colour": _v })} />
                    <BMInput value={border} onChange={(_v) => setData({ ...data, "border": _v })} number min={0} max={10} prefix={"WIDTH"} />
                </div>
                <div className="shim" /> <div className="shim" />

                {/* SPACER COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SPACER / COLOUR</Divider>
                <div style={{ "gap": "5px" }} className="float-flex">
                    <ColourPicker allow_none value={spacer_colour} onChange={(_v) => setData({ ...data, "spacer_colour": _v })} />
                    <BMInput value={spacer} onChange={(_v) => setData({ ...data, "spacer": _v })} number min={0} max={10} prefix={"WIDTH"} />
                </div>
                <div className="shim" /> <div className="shim" />



                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={"GAP"} />
                    </Space>
                    <div></div>
                </div>

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </div>
        )
    }

    const drawMobile = () => {

        return (
            <div>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />
                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COLUMNS</Divider>
                    <div className="float-flex">
                        <BMInput width={"50px"} value={mobile_columns} onChange={(e) => setData({ ...data, "mobile_columns": e })} number min={1} max={3} />
                    </div>
                </Spin>

                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={mobile_padding_x} onChange={(_v) => setData({ ...data, "mobile_padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={mobile_padding_y} onChange={(_v) => setData({ ...data, "mobile_padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ig_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <div></div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}